import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
function ManagerMessage() { 
  useEffect(() => {
    document.title = 'Manager Message -  Mercy Memorial School, Kanpur';  
}, []); 
const [data, setData] = useState([]);
useEffect(() => {
 const fetchData = async () => {
   try {
     const msgdata = await getPrincipalMessage();
    const data = msgdata.filter((item) => item.category === "Manager");
    
     setData(data);
   } catch (error) {
     console.error("Error fetching online registration data:", error);
   }  
 };
 fetchData();
}, []);
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>Manager's Message</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Manager's Message</h2>
            </div>
          </div> 
          <div className="row">
          {data.length > 0 && (
            <div className="clearfix">
               <LazyLoad> <img 
                src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
                className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                alt={data[0].name || 'Image'}
              /></LazyLoad>
              <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
              <p className="name">
                {data[0].name}<span> {data[0].category} </span>
              </p>
            </div>
          )}

          {data.length === 0  && (
            <div className="clearfix">
               <LazyLoad> <img 
                src="https://webapi.entab.info/api/image/MMSKN/public/Images/dummy.jpg" 
                className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                alt=""
              /></LazyLoad>
              <p>Our goal and vision is to provide the best facilities in education, ensuring that our students become trailblazers in whatever they undertake. We believe in nurturing the potential of each child, empowering them to dream big and to achieve greatness in their chosen fields.</p>

              <p>As George Bernard Shaw once wrote, “What we want is to see the child in pursuit of knowledge, and not knowledge in pursuit of the child.” This quote is perfectly embodied in our curriculum, which fosters curiosity, critical thinking and a love for learning. It is reflected in our motto:<b> "LET YOUR LIGHT SHINE."</b></p>
              
              <p>At our institution, we do not just impart knowledge; we cultivate creativity, resilience and leadership. Every student is encouraged to shine in their unique way, unlocking their full potential and contributing to the world with confidence and purpose. We aim to prepare them not just for academic success, but for life beyond the classroom.</p>
              <p className="name">
                 Ms. Rajni Shukla  <span>  Manager </span>
              </p>
            </div>
          )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ManagerMessage;
